const BRAND = "BioClock-in"; 

export function Footer() {
  return (
    <footer className="ftr">
      <div className="container ftr__wrap">
        <p className="ftr__copy">
          © {new Date().getFullYear()} {BRAND}. All rights reserved.
        </p>
        <nav className="ftr__nav">
          <a href="/privacy" className="ftr__link">Privacy</a>
          <a href="/terms" className="ftr__link">Terms</a>
        </nav>
      </div>
    </footer>
  );
}